import { render } from "./Logout.vue?vue&type=template&id=f7a984d4"
const script = {}

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__